import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  head: () => buildRouteHead("/", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en", replace: true });
  },
});
